import {Component,Injectable} from '@angular/core';
import { Headers,RequestOptions,URLSearchParams,Response, Http} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import 'rxjs/Rx';
import {CookieService} from "angular2-cookie/services/cookies.service";
import * as glob from "./global_url";
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS

@Injectable()
export class GuideService{
    private srv_url:string = glob.srv_url;
    private logger : Logger = new Logger();
    constructor(private http:Http, private cookie : CookieService){
      //this.srv_url = "https://www.extrus.net:19446/exafe_admin";
    }

      //------------------------------------------------------------------------------------//
    get(pathUrl:string, pathValue:string, param:URLSearchParams):Observable<any>{
        var url = this.srv_url + pathUrl;
        if(pathValue != null){url + "/" + pathValue}
        let headers = new Headers({ 'content-Type': 'application/json;charset=utf-8'});
        
        return this.http.get(url, {search :param, headers:headers})
                .map((res:Response) => res.json());
    }
    post(pathUrl:string,pathValue:string, param:URLSearchParams):Observable<any>{
        var url = this.srv_url + pathUrl;
        if(pathValue != null){ url = url + "/" + pathValue}
        let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'});
        let options = new RequestOptions({headers:headers});
        return this.http.post(url,param.toString(),options)
                .map((res:Response) => res.json());
    }
    /*put(pathUrl:string,body:any):Observable<any>{
        var url = this.srv_url + pathUrl;
        let headers = new Headers();
        headers.append('Content-Type', 'application/json;charset=euc-kr');
        if(this.cookie.get('xAuth')){
          headers.append('X-Auth-Token', this.cookie.get('xAuth'));
        }
        return this.http.put(url,JSON.stringify(body),{headers:headers})
                .map((res:Response) => res.json());
    }*/
    put(pathUrl:string,pathValue:string, body:any):Observable<any>{
        var url = this.srv_url + pathUrl;
        if(pathValue != null){ url = url + "/" + pathValue}

        let headers = new Headers();
        headers.append('Content-Type', 'application/json;charset=utf-8');
        this.logger.debug("put >> : " , JSON.stringify(body));
        return this.http.put(url,JSON.stringify(body),{headers:headers})
            .map((res:Response) => res.json());
    }
    del(pathUrl:string,pathValue:string,param:URLSearchParams){
        var url = this.srv_url + pathUrl;
        if(pathValue != null){ url = url + "/" + pathValue}
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8'});
        return this.http.delete(url,{search :param, headers:headers})
           .map((res:Response) => {
                this.logger.debug("res",res);
                res.json();
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/service/guide_service.component.ts